require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-weiden-bei-rechnitz.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-weiden-bei-rechnitz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-weiden-bei-rechnitz!./.cache/json/betreuungseinrichtungen-oberwart-weiden-bei-rechnitz.json
// module id = 1029
// module chunks = 231608221292675